import React,{Component} from 'react';
import { connect } from 'react-redux';
import base64  from 'base-64';
import * as Yup from 'yup';
import moment from 'moment';
import { resetUserPassword } from '../../actions/userAction';
import { Control } from 'react-redux-form';
import {mediaPath } from "../../config";

const validateSchema=Yup.object().shape({
				new_password: Yup.string()
					.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, {
                            message:'Please make sure your password meets all of the requirements.',
                            excludeEmptyString: true
                        })
				  .required('Please enter new password.'),
				   cnf_password: Yup.string()
				  .oneOf([Yup.ref('new_password'), ''], 'The new password and confirmation password do not match.').required('Please confirm your new password.'),
			});

class resetPassword extends Component {
	componentDidMount() {
		this.userId = base64.decode(this.props.match.params.userId);
	}
	linkExpire(){
		var getDateFromLink = new Date(this.props.match.params.currentTime * 1000);
		var currentDateTime = new Date();
		var diff =(currentDateTime.getTime() - getDateFromLink.getTime()) / 1000;
		diff /= 60;
		var minutes = Math.abs(Math.round(diff));
		if(minutes > 60)
		{
			return false;
		}else{
			return true;
		}
	}
	render(){
		return (
		 <div className="login-block">
                <div className="login-inner-wrapper">
					<div className="logo"><a onClick={()=>{
										this.props.history.push('/login');
									}}><img src={mediaPath+"osah-logo.png"} alt="OSAH Logo"/></a></div>
					{this.linkExpire() ? <div className="reset-your-password-section">
						<h2 className="title">Reset Your Password</h2>
						<div className="password-requirements-block">
							<p>Password Requirements</p>
							<ul>
								<li>An uppercase letter</li>
								<li>A lowercase letter</li>
								<li>A special character !@#$%^&*</li>
								<li>A number</li>
								<li>A minimum of 8 characters</li>
							</ul>
						</div>
						<div className="new-password-block">
							<label>New Password *</label>
							<Control.password  model="resetPassword.new_password"/>
						</div>
						<div className="confirm-password-block">
							<label>Confirm Password *</label>
							<Control.password  model="resetPassword.cnf_password"/>
						</div>
						<div className="btn-block">
							<button className="reset-btn" onClick={()=>{this.props.resetUserPassword(validateSchema,this.userId)}}>Reset</button>
						</div>
					</div>:<div className="email-sent-section">
						<h2 className="title">Link Expired</h2>
						<p className="subtitle">This link is expired. Please click below to regenerate your reset password link. <a onClick={()=>{
										this.props.history.push('/forgotPassword');
									}}>Try Again</a></p>
					</div>} 
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
  return {
	  resetPassword : state.resetPassword,
	  uiState : state.uiState
  };
}

export default connect(mapStateToProps,{resetUserPassword})(resetPassword);